var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundGridWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1432,
    height: 275,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "background-grid-white_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 2701",
    transform: "translate(-12099 -6000)",
    fill: "#fff",
    stroke: "#707070",
    d: "M0 0h1432v275H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 1",
    transform: "translate(12099 6000)",
    clipPath: "url(#background-grid-white_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7264"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7258",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9235",
    d: "M-12105.694-5882.761l126.4-82.448 98.055 199.235z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9236",
    d: "M-11882.538-5765.654l224.273-46.436-189.9-83.559"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9239",
    d: "M-12091.59-5722.934l209.639-43.429-223.743-116.554v159.983z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9240",
    d: "M-11586.868-5722.934l-295.352-43.482-224.438 43.482z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9241",
    d: "M-11979.299-5965.2l132.945 70.564-35.854 128.218z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9242",
    d: "M-12105.694-5950.041l-1.306 68.291 127.694-83.448z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9243",
    d: "M-11534.382-5798.767l29.146-54.024-153.838 40.516z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9244",
    d: "M-11505.236-5852.795l-29.861 54.672 177.043 40.138z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9245",
    d: "M-11545.28-5722.934l11.275-76.056-124.89-13.344 124.043 100.93"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9246",
    d: "M-11559.017-5715.655l201.944-42.2-177.543-41.168-14.692 99.951"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9249",
    d: "M-11070.394-5787.308l154.679-35.993 95.7 122.013z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9250",
    d: "M-11037.774-5944.342s-22.593 115.895-29.895 155.173-.407 2.188-.407 2.188l152.438-36.1z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9252",
    d: "M-10915.637-5823.302l77.6 108.493 117.5-94.405z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9253",
    d: "M-10920.054-5906.978h0l4.328 83.91 194.913 14.28z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9254",
    d: "M-11193.921-5887.277l-29.012 48.473-69.479-82.087z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9255",
    d: "M-11135.379-5888.177l67.614 101.133-92.269-11.968-.048-75.885z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9256",
    d: "M-11223.112-5839.191l28.472-48.348 34.607 12.7 2.2 78.382z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9238",
    d: "M-11658.863-5812.335l122.828 98.021-347.2-52.061z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9257",
    d: "M-11227.046-5720.594l-132.717-37.666 136.67-80.974-3.953 128.227"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9237",
    d: "M-11359.753-5758.275l136.66-80.953-69.336-81.671z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9258",
    d: "M-11233.194-5716.215l75.578-82.73-65.511-40.288-5.254 126.195"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9259",
    d: "M-11396.004-5839.944l36.15 81.369-145.314-94.16z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9260",
    d: "M-11292.412-5920.89l-103.961 80.69 36.661 82.03z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9261",
    d: "M-10930.299-5910.282l-107.457-34.037 122.231 121.572-4.569-84.255z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9262",
    d: "M-10665.694-5915.639l-255.164 8.552 199.817 98.3 60.912-110.558"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9263",
    d: "M-10835.787-5716.732l114.784-92.153 62.734 95.161z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9264",
    d: "M-10665.694-5910.803l-55.339 101.959 65.574 102.121z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9248",
    d: "M-11157.916-5799.137l90.294 12.056-171.139 74.862z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9266",
    d: "M-11107.446-5905.326l-28.048 17.187 67.711 101.111 30.011-157.291z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9267",
    d: "M-11235.816-5716.509l167.991-70.612 199.986 66.733z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9247",
    d: "M-11229.324-5722.814l-130.2-35.467-191.766 39.957z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9268",
    d: "M-10735.975-5971.587l80.929-28.4-9.622 85.456z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9269",
    d: "M-10920.83-5906.978l264.6-8.728-79.625-56.036-184.977 64.763"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundGridWhite);
export default __webpack_public_path__ + "static/media/background-grid-white.e4056b2e40b3a56ca43c42662bc7241d.svg";
export { ForwardRef as ReactComponent };